export default [
    {
        path: "/hp_activity/:matchid",
        name: "hp_activity",
        props:(route)=>({
            matchid:route.params.matchid,
            // item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "home" */"../views/Huang/Activity/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"个人赛"
        }
    },
    {
        path: "/hp_join/:matchid/:type",
        name: "hp_join",
        props:(route)=>({
            matchid:route.params.id,
            type:route.params.type
        }),
        component: () => import(/* webpackChunkName: "home" */"../views/Huang/Join/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"上传照片"
        }
    },
    {
        path: "/hp_group/:matchid",
        name: "hp_group",
        props:(route)=>({
            matchid:route.params.matchid,
            // item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "home" */"../views/Huang/Group/Index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"团队"
        }
    },
    {
        path: "/hp_luckdraw/:acid",
        name: "hp_luckdraw",
        props:(route)=>({
            acid:route.params.acid,
            // item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "activity" */"../views/Huang/LuckDraw/Index.vue"),
        meta: {
            title: "幸运抽奖",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/hp_question/:matchid",
        name: "hp_question",
        props:(route)=>({
            matchid:route.params.matchid,
            // item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "activity" */"../views/Huang/Questions/Index.vue"),
        meta: {
            title: "答题",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/hp_rank/:matchid",
        name: "hp_rank",
        props:(route)=>({
            matchid:route.params.matchid,
            // item_id:route.params.item_id
        }),
        component: () => import(/* webpackChunkName: "activity" */"../views/Huang/Rank/Index.vue"),
        meta: {
            title: "排行",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/hp_map",
        name: "hp_map",
        component: () => import(/* webpackChunkName: "activity" */"../views/Huang/Group/map.vue"),
        meta: {
            title: "地图",
            showloading: true,
            requiresAuth: true
        }
    }
]